<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="pa-2" no-gutters>
        <custom-popup
          v-model="ready"
          :cons="{ title: 'نمونه کارت ویزیت های آماده' }"
          hide-confirm
          hide-overlay
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <v-card class="p-5" flat>
            <prepared-cards
              v-model="cardTexts"
              :orders.sync="orders"
              :theme.sync="theme"
              type="visitCard"
              @closeModel="ready = false"
            />
          </v-card>
        </custom-popup>

        <v-col cols="12" md="4" />

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 10px; height: fit-content"
        >
          <component
            :is="theme"
            v-model="cardTexts"
            :data="cardTexts"
            :orders.sync="orders"
          />
        </v-col>

        <v-col
          :md="Object.keys(cardTexts).length > 0 ? 8 : 12"
          class="pa-2 px-0"
          cols="12"
        >
          <v-row>
            <v-col cols="12" md="12">
              <div class="rowinfo justify-end">
                <v-btn class="float-end btn-download" @click="ready = true">
                  کارت ویزیت های آماده
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-submitData`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="کارت ویزیت های آماده"
                />
              </div>
            </v-col>
          </v-row>

          <div>
            <!-- <site-selector v-model="sites" /> -->
            <div
              class="col-md-12 mt-3"
              style="border-bottom: 1px dashed #7e8299"
            >
              <p>آدرس</p>
              <div>
                <div>
                  <v-text-field
                    :error-messages="item.error"
                    :rules="urlRules"
                    outlined
                    dense
                    v-model="item.url"
                    :placeholder="item.hint"
                    clearable
                    v-bind="$attrs"
                    clear-icon="mdi-close-circle-outline"
                    style="direction: ltr"
                    direction="ltr"
                  >
                    <template v-slot:prepend>
                      <svg-base
                        class="mt-0"
                        v-if="item.attrs"
                        view-box="0 0 60 60"
                        width="45"
                        height="45"
                      >
                        <svg-location class="mt-0" />
                      </svg-base>
                    </template>
                  </v-text-field>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12">
          <div class="rowinfo justify-end">
            <v-btn
              :loading="loading"
              class="submit-btn float-left contnetinfo"
              @click="submitData"
            >
              <span class="fa fa-save ml-2" style="font-size: 12pt"></span>
              ثبت درخواست
            </v-btn>

            <help-info
              :element-name="`${serviceName}-${componentName}-submitData`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="ثبت درخواست"
            />
          </div>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import PreparedCards from "@/view/pages/qrland/preparedCards";
import VisitThemeTwo from "@/view/pages/qrland/components/themes/visitThemeTwo";
import ListExpansion from "@/view/content/fragments/listExpansion";
import siteSelector from "@/view/pages/robot/autoCard/siteSelector";
import { Bus, RobotAxios } from "@/main";
import MobileViwer from "@/view/pages/qrland/components/mobileViwer.vue";
import VisitThemeFlipped from "@/view/pages/qrland/components/themes/visitThemeFlipped.vue";
import svgBase from "@/view/content/svgLoader/svgBase";
import svgLocation from "../../../content/svgLoader/svgFile/svgLocation.vue";

export default {
  name: "createAuto_2",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    ListExpansion,
    PreparedCards,
    VisitThemeTwo,
    MobileViwer,
    VisitThemeFlipped,
    siteSelector,
    svgBase,
    svgLocation,
  },

  data() {
    return {
      item: {
        label: "آدرس",
        socialText: "",
        text: "لینک سایت مورد نظر را وارد نمایید",
        value: "address",
        svg: "svgLocation",
        pattern: "",
        error: "",
        prefix: "URL",
        img: "/media/socialIcon/40icon/location.svg",
        attrs: { bgColor: "#fff", hover: "#90caf9" },
      },
      urlRules: [
        (value) =>
          this.isURL(value) ||
          " https://terminalads.com :   لینک سایت باید بصورت روبرو وارد شود",
      ],
      helpData: [],
      serviceName: "Qrland",
      componentName: "create-auto2",
      theme: "VisitThemeTwo",
      cardTexts: {
        // photo: {
        //   headBackground: "/media/defaults/visitTwoDefault.webp",
        //   profile: null,
        //   hasWelcome: false,
        //   welcome: "",
        //   gallery: [],
        // },
        // pallete: {
        //   headColor: "linear-gradient(to top left , #00BCD4FF, #2F0743FF)",
        //   bodyColor: "linear-gradient(to top left , #006064FF, #03A9F4FF)",
        //   textColor: "#ffffff",
        //   borderColor: "#393939",
        // },
        // coordinates: [],
        // address: "",
        // apiKey:
        //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0",
        // organizationName: "",
        // subOrgan: "",
        // companyNumber: "",
        // phoneNumber: [],
        // aboutUs: "",
        // socialMedia: {},
        // extraFields: [],
        // video_single: null,
        // video_gallery: [],
        // userName: "",
        // workField: "",
        // fax: "",
        // location: "",
        // codePostal: "",
        // email: "",
        // website: "",
      },
      ready: false,
      loading: false,
      smartId: "",
      componentsList: [
        {
          name: "siteSelector",
          value: "",
          title: "اطلاعات کاربری",
          subtitle: "",
          icon: "account-outline",
        },
      ],
      sites: "",
      orders: [],
    };
  },
  mounted() {
    // this.$root.$on("clearDefaultData", () => {
    //   this.sites = {};
    //   this.smartId = "";
    //   this.cardTexts = {};
    // });
    Bus.$on("updateDest", (val) => {
      this.smartId = val;
    });
  },
  watch: {
    sites(newValue) {
      console.log("Sites updated in createAuto_2:", newValue);
    },
  },
  methods: {
    isURL(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      if (regex.test(str) || without_regex.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    submitData() {
      // const type = this.sites?.divar ? "divar" : "address";

      // if (type === "divar") {
      //   this.submitDivar();
      // } else {
      //   if (this.smartId === "") {
      //     this.$toast.error("مدل خودرا انتخاب نمایید!");
      //     return;
      //   }
      //   if (
      //     !this.sites[type] ||
      //     !Array.isArray(this.sites[type]) ||
      //     this.sites[type].length === 0
      //   ) {
      //     this.$toast.error("فیلد درخواستی را تکمیل کنید!");
      //     return;
      //   }
      //   if (this.sites[type][0].url === "") {
      //     this.$toast.error("فیلد درخواستی را تکمیل کنید!");
      //     return;
      //   }

      if (!this.item.url || this.item.url.trim() === "") {
        this.$toast.error("فیلد درخواستی را تکمیل کنید!");
        return;
      }
      this.loading = true;
      RobotAxios.post(
        `/api/enamad/manual?url=${this.item.url.replace(
          /(https|http):\/\//gm,
          "",
        )}&qr_id=${this.smartId}`,
        {
          token: localStorage.getItem("id_token"),
        },
      )
        .then((response) => {
          this.loading = false;
          this.$toast.success("کارت ویزیت شما با موفقیت ساخته شد.");
          this.sites = "";
          this.$router.push({ name: "qr.list" });
        })
        .catch((err) => {
          this.loading = false;
          if (err.response?.data?.message === "site already exists") {
            this.$toast.error("کارت ویزیت آگهی مورد نظر، قبلا ساخته شده است.");
          } else {
            this.$toast.error(
              "ساخت کارت ویزیت با خطا مواجه شد، مجدد تلاش کنید.",
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // submitDivar() {
    //   if (this.smartId === "") {
    //     this.$toast.error("مدل خودرا انتخاب نمایید!");
    //     return;
    //   }
    //   if (
    //     !this.sites.divar ||
    //     !Array.isArray(this.sites.divar) ||
    //     this.sites.divar.length === 0
    //   ) {
    //     this.$toast.error("فیلد درخواستی را تکمیل کنید!");
    //     return;
    //   }
    //   if (this.sites.divar[0].url === "") {
    //     this.$toast.error("فیلد درخواستی را تکمیل کنید!");
    //     return;
    //   }

    //   this.loading = true;
    //   const temp = this.sites.divar[0].url.split("/");
    //   let urlDivar = !temp.includes("marketplace")
    //     ? "https://divar.ir/v/" + temp[temp.length - 1]
    //     : this.sites.divar[0].url;

    //   RobotAxios.post(
    //     `/api/divar/manual?url=${urlDivar}&qr_id=${this.smartId}`,
    //     {
    //       token: localStorage.getItem("id_token"),
    //     }
    //   )
    //     .then((response) => {
    //       this.loading = false;
    //       this.$toast.success("کارت ویزیت شما با موفقیت ساخته شد.");
    //       this.sites.address[0].url = "";
    //       this.$router.push({ name: "qr.list" });
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //       if (err.response?.data?.message === "site already exists") {
    //         this.$toast.error("کارت ویزیت آگهی مورد نظر، قبلا ساخته شده است.");
    //       } else if (err.response?.data?.message) {
    //         const englishRegex = /^[a-zA-Z]+$/;
    //         if (englishRegex.test(err.response.data.message)) {
    //           this.$toast.error(
    //             "دریافت اطلاعات با خطا مواجه شد،مجدد تلاش کنید."
    //           );
    //         } else {
    //           this.$toast.error(err.response.data.message);
    //         }
    //       } else {
    //         this.$toast.error("دریافت اطلاعات با خطا مواجه شد،مجدد تلاش کنید.");
    //       }
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
  },
};
</script>

<style scoped></style>
